import { FilterConfigType, FilterParentType } from '../types/filters'
import { getFiltersFromLocalStorage, getDateTime, setFiltersInLocalStorage } from '../utils/helpers'
import { useState } from 'react'

export const InitialState: FilterConfigType = {
  selectedStaticRange: 'today',
  selectedCompareStaticRange: 'thisWeek',
  comparison: 'none',
  lastUpdated: `${getDateTime(new Date()).date} at ${getDateTime(new Date()).time}`
}

export const InitalStateWithComparison: FilterConfigType = {
  ...InitialState,
  comparison: 'previous',
  selectedCompareStaticRange: 'today'
}

type InitalStateType = typeof InitialState | typeof InitalStateWithComparison

export const useDateFilters = (filterParent: FilterParentType, customInitialState?: InitalStateType) => {
  const [dateFilter, setDateFilter] = useState<FilterConfigType>(
    getFiltersFromLocalStorage(filterParent) ?? customInitialState ?? InitialState
  )

  const setDateFilterCtx = (filterObject: FilterConfigType) => {
    setDateFilter(filterObject)
    setFiltersInLocalStorage(filterParent, filterObject)
  }

  return {
    dateFilter,
    setDateFilterCtx
  }
}
